<template>
  <div class="user">
    <Globalheader title url="/jdtrademark" name="首页" />

    <div class="user-main">
      <div class="user-main-mid">
        <div class="user-main-left">
          <h1>专家辅助商标注册</h1>
          <p>
            <span>千万企业的共同选择值得您的信奈专属顾问一对一全流程服务</span>
            <span>经验丰富专家把关，显著提升成功率</span>
            <span>优化注册方案，全方位保护</span>
            <span>专享绿色通道，材料齐全，30分钟申报</span>
          </p>
        </div>
        <div class="user-main-right">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <div class="user-footer"></div>
  </div>
</template>

<script>
import Globalheader from "@/components/globalheader";
export default {
  components: {
    Globalheader
  },
  data() {
    return {
      activeName: "first"
    };
  },
  mounted() {}
};
</script>

<style lang="scss">
.user {
  width: 100%;
  .user-main {
    width: 100%;
    height: 840px;
    background: url("../../../assets/imgs/loginBanner.png") no-repeat;
    background-size: 100% 100%;
    .user-main-mid {
      max-width: 1240px;
      min-width: 1000px;
      height: 100%;
      padding: 0 20px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding-top: 123px;
    }
  }
}
.user-main-left {
  width: 510px;
  margin-top: 100px;
  h1 {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 37px;
  }
  p {
    margin-top: 56px;
    span {
      display: block;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #f8f8f8;
      line-height: 42px;
    }
  }
}
.user-main-right {
  width: 555px;
}
</style>
